import { Delete as DeleteIcon } from 'almanac-ui/icons/16/Delete'
import { getContainerBeforePos } from 'common/Prose/utils/getContainerBeforePos'
import { InlineFormatButton } from 'components/InlineFormatBar/components/InlineFormatButton/InlineFormatButton'
import { NodeSelection } from 'prosemirror-state'
import { type EditorView } from 'prosemirror-view'
import type React from 'react'

export type DeleteInlineFormatButtonProps = {
  view: EditorView
  callback?: () => void
  overrideSelectionRange?: { from: number; to: number }
}

export const DeleteInlineFormatButton: React.FC<React.PropsWithChildren<DeleteInlineFormatButtonProps>> = ({
  view,
  callback,
  overrideSelectionRange,
}) => {
  const deleteText = () => {
    callback?.()
    const { state, dispatch } = view

    if (state.selection instanceof NodeSelection) {
      dispatch(state.tr.delete(state.selection.$from.pos, state.selection.$to.pos))
      return
    }
    if (overrideSelectionRange) {
      const { from, to } = overrideSelectionRange
      dispatch(state.tr.delete(from, to))
    } else {
      const containerFromPos = getContainerBeforePos(state.doc, state.selection.from)
      const containerToPos = getContainerBeforePos(state.doc, state.selection.to)
      const containerToAfterPos = state.doc.resolve(containerToPos.pos + (containerToPos.nodeAfter?.nodeSize || 0))

      const tr = state.tr
      tr.delete(containerFromPos.pos, containerToAfterPos.pos)
      dispatch(tr)
    }
  }

  return (
    <InlineFormatButton
      isDisabled={!view.editable}
      onClick={deleteText}
      data-testid="inline-delete-button"
      label="Delete"
      shortcutKeys="del"
    >
      <DeleteIcon />
    </InlineFormatButton>
  )
}
